<template>
	<!-- g-tit01 -->
	<div class="g-tit01">
		<i class="left" :style="{marginRight: offset + 'px'}"></i>
		<span class="tit01" ref="title">{{ title }}</span>
		<i class="right" :style="{marginLeft: offset + 'px'}"></i>
	</div>
	<!-- g-tit01 end -->
</template>

<script>
	export default {
		name: "gTit01",
		data: () => { 
			return {
				offset: 0
			}
		},
		props: {
			title: {
				type: String,
				required: true,
				default: () => {
					return ""
				}
			}
		},
		mounted() {
			let width = this.$refs.title.clientWidth;
			this.offset = width/2;
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/components/gTit01.vue